// external
import styled from 'styled-components';

export const SELECTED_ROW_CLASSNAME = 'products-table-selected-row';
export const HOVER_ROW_CLASSNAME = 'ant-table-row';

export const MANUAL_VPP_EDIT_CELL_CLASSNAME = 'manual-vpp-edit-cell';

export const PRODUCT_PLAN_CLASSNAME = 'products-table-product-plan';
export const PRODUCT_NAME_CLASSNAME = 'products-table-product-name';
export const PRODUCT_PROVIDER_CLASSNAME = 'products-table-product-provider';
export const PRODUCT_OVERRIDED_CLASSNAME = 'products-product-overrided';

export const RATES_LOADING_SPINNER = 'rates-loading-spinner';

export const VehicleProtectionTableActions = styled.div`
    button {
        width: 50%;
    }
`;

export const VehicleProtectionTableContainer = styled.div<{ $readOnly?: boolean }>`
    table tbody {
        tr td {
            vertical-align: middle;
        }

        // a Manual VPP row being edited keeps its cells top aligned, so the inputs stay in place
        // instead of jumping up when a validation message is rendered underneath one of them
        tr:has(.${MANUAL_VPP_EDIT_CELL_CLASSNAME}) td {
            vertical-align: top;
        }

        tr.${SELECTED_ROW_CLASSNAME} {
            td {
                background-color: ${({ theme, $readOnly }) =>
                    $readOnly ? theme.tokens.SemColorSurfaceSubdued : theme.tokens.BaseColorBlue50};
            }

            td:first-of-type {
                box-shadow: inset 0.5rem 0 ${({ theme }) => theme.tokens.ComponentTableCheckedBorder};
            }
            td:first-of-type.${PRODUCT_OVERRIDED_CLASSNAME} {
                box-shadow: inset 0.5rem 0 ${({ theme }) => theme.tokens.BaseColorGold500};
            }

            background-color: ${({ theme }) => theme.tokens.BaseColorBlue50};
        }

        tr.${HOVER_ROW_CLASSNAME}:hover {
            background-color: ${({ theme }) => theme.tokens.BaseColorBlue50};
        }

        td.${PRODUCT_PLAN_CLASSNAME} > div,
        td.${PRODUCT_NAME_CLASSNAME} > div,
        td.${PRODUCT_PROVIDER_CLASSNAME} > div {
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            white-space: normal;
            overflow: hidden;
            word-break: break-word;
        }

        .${RATES_LOADING_SPINNER} {
            display: flex;
            justify-content: center;

            & svg {
                height: 16px;
                width: 16px;
            }

            & #ids-spinner-root {
                // need to override inline styles, as there is no way to pass them as property
                height: 16px !important;
                width: 16px !important;
            }

            & #interstitial-overlay-root {
                min-width: 18px;
                min-height: 18px;
                background-color: transparent;
            }

            & #interstitial-content-root {
                box-shadow: none;
                background: none;
            }
        }
    }
`;

export const VppTableCheckBoxContainer = styled.div<{ $isEditable?: boolean }>`
    display: flex;
    justify-content: center;
    // cells of a Manual VPP row being edited are top aligned, so nudge the checkbox down to the inputs
    margin-top: ${({ $isEditable }) => ($isEditable ? '8px' : '0')};

    span > input {
        margin: 0;
    }

    span > svg {
        width: auto;
        height: auto;
    }
`;

export const ManuallyAddedSign = styled.div`
    border-left: 4px solid #ebb000;
    padding-left: 2px;
    color: #5a5a5a;
    font-size: 0.715rem;
    margin-top: 8px;
`;
